import { TableLoading } from '@common/ui/TableLoading';
import { PagedPagination } from '@common/ui/PagedPagination';
import { AccessSessionsGroupClientModel, PaginationClientInfoModel } from '@apono/client-app-sdk';
import AccessSessionGroup from '@MyAccess/organisms/AccessSessionGroup';

export interface AccessGroupIcon {
  svg: string;
  alt: string;
}

export function AccessSessionGroupList({
  accessGroups,
  isLoading,
  pagination,
  onPageChange,
}: {
  accessGroups: AccessSessionsGroupClientModel[];
  isLoading: boolean;
  pagination: PaginationClientInfoModel;
  onPageChange: (page: number) => void;
}) {
  return (
    <>
      {accessGroups.map((group) => (
        <AccessSessionGroup key={group.integration?.id ?? group.sessions[0].id} group={group} />
      ))}
      <TableLoading loading={isLoading} />
      {pagination.total && (
        <PagedPagination pagination={pagination} isLoading={isLoading} onChange={onPageChange} itemsName="sessions" />
      )}
    </>
  );
}
